import { render } from "./AbstractMenuModal.vue?vue&type=template&id=5cca9fc0"
import script from "./AbstractMenuModal.vue?vue&type=script&lang=js"
export * from "./AbstractMenuModal.vue?vue&type=script&lang=js"

import "./AbstractMenuModal.vue?vue&type=style&index=0&id=5cca9fc0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__